import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Table, Typography, Space, Card, message, Spin } from 'antd';

const { Text, Title } = Typography;

const InscriptionValider = () => {
  const [preinscrits, setPreinscrits] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const employerStr = localStorage.getItem('employer');

  const currentUser = employerStr ? JSON.parse(employerStr) : null;
  const isAdmin = currentUser?.roles?.some(r => r.nomrole === 'ROLE_ADMIN');
  const isInfluenceur = currentUser?.roles?.some(r => r.nomrole === 'ROLE_INFLUENCEUR');
  const currentInfluenceurId = currentUser?.id;

  useEffect(() => {
    fetchPreinscrits();
  }, []);

  const fetchPreinscrits = () => {
    setLoading(true);

    axios.get('http://localhost:8080/admin/api/getPreinscris', {
      headers: {
        'Authorization': 'Basic ' + token,
        'Content-Type': 'application/json',
      },
    })
      .then(res => {
        const allData = res.data.filter(p => p.inscriptionValider);

        let filteredData = [];

        if (isAdmin) {
          filteredData = allData;
        } else if (isInfluenceur) {
          filteredData = allData.filter(p =>
            p.influenceur?.userSystem?.id === currentInfluenceurId
          );
        }

        setPreinscrits(filteredData);
      })
      .catch(err => {
        console.error(err);
        message.error('Erreur lors de la récupération des préinscrits');
      })
      .finally(() => setLoading(false));
  };

  // Calcul du solde affiliation pour l'influenceur (20 000 * nombre de préinscrits validés)
  const soldeAffiliation = isInfluenceur ? preinscrits.length * 20000 : 0;

  // Colonnes de base
  const baseColumns = [
    {
      title: 'Nom',
      dataIndex: ['userSystem', 'nom'],
      key: 'nom',
      render: text => <Text strong>{text}</Text>,
    },
    {
      title: 'Prénom',
      dataIndex: ['userSystem', 'prenom'],
      key: 'prenom',
    },
    {
      title: 'Téléphone',
      dataIndex: ['userSystem', 'telephone'],
      key: 'telephone',
    },
    {
      title: 'Email',
      dataIndex: ['userSystem', 'email'],
      key: 'email',
      render: email => <a href={`mailto:${email}`}>{email}</a>,
    },
  ];

  // Colonne "Influenceur" visible seulement pour admin
  const adminOnlyColumn = {
    title: 'Influenceur',
    dataIndex: ['influenceur', 'userSystem', 'nom'],
    key: 'influenceur',
    render: (_, record) => {
      const infUser = record.influenceur?.userSystem || {};
      return (
        <Space direction="vertical" size={0}>
          <Text strong>{infUser.nom}</Text>
          <Text type="secondary">{infUser.email}</Text>
          <Text type="secondary">{infUser.telephone}</Text>
        </Space>
      );
    },
  };

  // Colonnes selon rôle
  const columns = isAdmin ? [...baseColumns, adminOnlyColumn] : baseColumns;

  return (
    <Card
      title={<Title level={3} style={{ color: '#1890ff', marginBottom: 0 }}>Inscriptions validées</Title>}
      style={{ maxWidth: 1000, margin: '2rem auto', boxShadow: '0 8px 16px rgba(0,0,0,0.1)' }}
    >
      {loading ? (
        <Space style={{ width: '100%', justifyContent: 'center', padding: '2rem' }}>
          <Spin size="large" tip="Chargement..." />
        </Space>
      ) : (
        <>
          {(isAdmin || isInfluenceur) && (
            <Space
              direction="vertical"
              style={{ width: '100%', marginBottom: 16, textAlign: 'center' }}
            >
              <Text strong style={{ fontSize: 16 }}>
                Total des inscriptions validées : {preinscrits.length}
              </Text>
              {isInfluenceur && (
                <Text strong style={{ fontSize: 16, color: '#52c41a' }}>
                  Solde affiliation : {soldeAffiliation.toLocaleString('fr-FR')} CFA
                </Text>
              )}
            </Space>
          )}

          <Table
            columns={columns}
            dataSource={preinscrits}
            rowKey={record => record.id}
            pagination={{ pageSize: 5 }}
            bordered
            scroll={{ x: 900 }}
          />
        </>
      )}
    </Card>
  );
};

export default InscriptionValider;
